<template>
	<div>
		<AdButlerItem :ad-id="751413" />
	</div>
</template>
<script setup>
import { AdButlerItem } from "@stockstotrade_com/stt-ts-shared-lib";
const props = defineProps(["isVisible"]);
</script>
<style lang="scss">
@use "../../assets/colors" as *;
@use "../../assets/mixins" as *;
.nav-link {
	color: #fff;
	font-size: 20px;
	font-style: normal;
	height: 24px;
	font-weight: 400;
	line-height: 40px;
	/* 36px */
	letter-spacing: 0.44px;
	position: relative;
	padding: 0 16px;
	visibility: visible;
}

@keyframes pulse-red {
	0% {
		transform: scale(0.95);
		box-shadow: 0 0 0 0 rgba(255, 82, 82, 0.7);
	}

	70% {
		transform: scale(1);
		box-shadow: 0 0 0 10px transparent;
	}

	100% {
		transform: scale(0.95);
		box-shadow: 0 0 0 0 transparent;
	}
}

.blob {
	background: #000;
	border-radius: 50%;
	box-shadow: 0 0 0 0 #000;
	margin: 14px 8px 15px 12px;
	min-height: 10px;
	height: 10px;
	min-width: 10px;
	width: 10px;
	display: block;
	content: "";
	transform: scale(1);
	animation: pulse-black 2s infinite;
	&.red {
		background: #ff5252;
		box-shadow: 0 0 0 0 #ff5252;
		animation: pulse-red 2s infinite;
	}
}

.nav-link.live {
	align-items: center;
	background: #b91c1c;
	border-radius: 8px;
	color: #fff;
	font-size: 16px;
	font-weight: 600;
	gap: 8px;
	line-height: 1;
	padding: 4px 16px;
	height: 40px;
	@include breakpoint(lg) {
		margin-left: 16px;
	}
}

.search-btn:hover {
	path {
		fill: $yellow-500;
	}
}

.fade-enter-active,
.fade-leave-active {
	transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
	opacity: 0;
}
.fade-enter-active .search-bar,
.fade-leave-active .search-bar {
	transition: transform 0.5s ease;
}

.fade-enter-from .search-bar,
.fade-leave-to .search-bar {
	transform: translateY(-32px);
}

.slide-left-enter-active,
.slide-left-leave-active {
	transition: left 0.25s linear;
}

.slide-left-enter-from,
.slide-left-leave-to {
	left: -100%;
}
</style>
